@if (this.seznamSablonState.vm$ | async; as data) {
<div class="nadpis">
  <p class="large-text">Zadejte kritéria typu oprávnění k zastupování, které chcete vyhledat.</p>
</div>

<ui-form #form [formGroup]="filterForm" (handleSubmit)="submitFilter()" class="mb-3" [attr.data-cy]="Cy_Katalog.form">
  <p-accordion [multiple]="true" [activeIndex]="accordionActiveIndexArr">
    <p-accordionTab [attr.data-cy]="Cy_Katalog.specifikaceTab">
      <ng-template pTemplate="header"> Rozšířené filtrování </ng-template>
      <reza-seznam-sablon-filter></reza-seznam-sablon-filter>
      <ui-buttons>
        <button label="Vyhledat" class="wider" type="submit" pButton [attr.data-cy]="Cy_Katalog.search"></button>
        <button
          label="Smazat kritéria"
          type="button"
          (click)="clearFilter()"
          class="p-button-outlined wider"
          pButton
          [attr.data-cy]="Cy_Katalog.clear"></button>
      </ui-buttons>
    </p-accordionTab>
  </p-accordion>
</ui-form>

<p-table
  #table
  (onLazyLoad)="onLazyLoad($event)"
  [lazy]="true"
  [lazyLoadOnInit]="false"
  [scrollable]="true"
  [scrollHeight]="dynamicHeight"
  [value]="data.result.content || []"
  [paginator]="true"
  [rows]="data.filter.pageAndSortList?.count"
  [first]="data.filter.pageAndSortList?.start"
  [totalRecords]="data.result.total || 0"
  [rowsPerPageOptions]="DEFAULT_PAGE_OPTION"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem', 'margin-top': '0px' }"
  styleClass="p-datatable-lg"
  currentPageReportTemplate="Zobrazeno {first}-{last} z {totalRecords} záznamů"
  paginatorDropdownAppendTo="body"
  responsiveLayout="scroll"
  contentTemplate
  [attr.data-cy]="Cy_Katalog.table">
  <ng-template pTemplate="header">
    <tr>
      <th>Identifikátor</th>
      <th>Název</th>
      <th>Verze</th>
      <th>Typ</th>
      <th>Platnost od</th>
      <th>Platnost do</th>
      <th>Gestor</th>
      <th>Schváleno</th>
      <th>Publikováno</th>
      <th>Dokumentace</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-sablona>
    <tr>
      <td>
        <a [routerLink]="" (click)="downloadPdf(sablona.id)" target="_blank" class="link">
          {{ sablona.interni_id }}
        </a>
      </td>
      <td>{{ sablona.nazev }}</td>
      <td>{{ sablona.verze }}</td>
      <td>
        <ui-status-indicator [statusLabels]="publicSablonyTypStatuses" [status]="sablona.typ"></ui-status-indicator>
      </td>
      <td>{{ sablona.platnostOd | date : 'dd.MM.yyyy' }}</td>
      <td>{{ sablona.platnostDo | date : 'dd.MM.yyyy' }}</td>
      <td>{{ sablona.kodOvm + ' - ' + sablona.nazevOvm }}</td>
      <td>{{ sablona.datumSchvaleni | date : 'dd.MM.yyyy' }}</td>
      <td>{{ sablona.datumPublikace | date : 'dd.MM.yyyy' }}</td>
      <td>
        <!-- @if(sablona.dokumentace) { Zatim neni zadny identifikator v dto zda existuje dokumentace -->
        <a
          [routerLink]=""
          (click)="downloadDokumentace(sablona.id)"
          target="_blank"
          class="link"
          [attr.data-cy]="Cy_Katalog.dokumentaceButton">
          Soubor
        </a>
        <!-- } -->
      </td>
    </tr>
  </ng-template>
</p-table>
<ui-buttons>
  <button class="m-1 mb-4" label="Zpět" (click)="goBack()" pButton></button>
</ui-buttons>
}
